import { t } from '../../../../i18n.es.js';
import React from 'react';
import { styled } from '@teko/ui';
import { RatingStatistic } from '../RatingStatistic/RatingStatistic.es.js';
import { RatingStars } from '../RatingStars/RatingStars.es.js';

const Average = styled.div`
  font-weight: 500;
  font-size: 36px;
`;
const Total = styled.span`
  color: #b4b4b4;
`;
const TotalComment = styled.div`
  font-size: 14px;
  margin-bottom: 24px;
  color: #848788;
`;
const VoteCount = styled.span`
  color: #333333;
`;
const OverallRating = ({
  average,
  totalRating,
  statisticVotes
}) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, average ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Average, null, average, /* @__PURE__ */ React.createElement(Total, null, "/5")), /* @__PURE__ */ React.createElement(RatingStars, {
    stars: average,
    readOnly: true,
    starWidth: 20
  }), /* @__PURE__ */ React.createElement(TotalComment, null, t("Trung b\xECnh c\u1EE7a:"), /* @__PURE__ */ React.createElement(VoteCount, null, " ", totalRating, t("nh\u1EADn x\xE9t")))) : /* @__PURE__ */ React.createElement("div", {
    className: "mb26"
  }, t("Ch\u01B0a c\xF3 \u0111\xE1nh gi\xE1 n\xE0o")), /* @__PURE__ */ React.createElement(React.Fragment, null, Array.from(Array(5).keys()).reverse().map((i) => {
    return /* @__PURE__ */ React.createElement(RatingStatistic, {
      key: `rating-statistic-${i}`,
      stars: i + 1,
      voteCount: statisticVotes[i + 1],
      totalRating
    });
  })));
};

export { OverallRating };
